import React, { useEffect } from "react";
import { Outlet, useNavigate, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function GoldLoanLayout() {
  const navigate = useNavigate();

  const appId = useSelector((state) => state.token.appId);
  const productType = useSelector((state) => state.token.productType);
  const user = useSelector((state) => state.user);
  const glEditUserDetail = useSelector((state) => state.temp.glEditUserDetail);

  const pathName = window.location.pathname;

  // prettier-ignore
  useEffect(() => {
    if (user.userId) {
      // user data is fetched
      if (!appId && pathName !== `/user/gold-welcome-back` && user.gl_completed === 1) {
        // if welcome back process is not done for existing profile, redirect to welcome back
        navigate(`/user/gold-welcome-back`, { replace: true });
      } else if (pathName === `/user/gold-loan-detail` && user.gl_completed !== 0 && !glEditUserDetail) {
        // if user detail is filled up and return to profile is not done, redirect to offers or lenders page
        navigate(`/user/gold-offers`, { replace: true });
      } else if (pathName !== `/user/gold-loan-detail` && user.gl_completed !== 1) {
        // if user detail is not filled up, redirect to user detail
        navigate(`/user/gold-loan-detail`, { replace: true });
      }
    }
  }, [user, pathName]);

  if (productType !== "Gold Loans") {
    // not the correct product type, redirect to products
    return <Navigate to={`/products`} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
}
